import { compile } from 'path-to-regexp'

export const formatRoute = (route, params = {}) => compile(route)(params)

export default {
  base: '/:shortcode/',
  getStarted: '/:shortcode/get-started/',
  selectReward: '/:shortcode/select-reward/',
  review: '/:shortcode/review/',
  orderDetails: '/:shortcode/order-details/',
  leaderboard: '/:shortcode/leaderboard/',
}
